export default __webpack_public_path__ + "static/media/Green0000.6773f541.png";